export default {
  listaParametros: [],
  parametro: {
    tipo: '',
    lista: true,
    nome: '',
    valor: '',
    comentario: '',
  },
}
